import {
  SIGNUP_INACTIVE,
  UPDATE_SIGNUP_STATUS,
  UPDATE_SIGNUP_EMAIL,
} from '../constants';

export default (
  state = {
    signup_status: SIGNUP_INACTIVE,
    email: localStorage.getItem('email_verification_to'),
  },
  action
) => {
  switch (action.type) {
    case UPDATE_SIGNUP_STATUS:
      return { ...state, signup_status: action.payload };

    case UPDATE_SIGNUP_EMAIL:
      return { ...state, email: action.payload };
    default:
      return state;
  }
};
